import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { SharedModule } from "../../../shared/shared.module";
import { CompanyAttachmentComponent } from "./company-attachment.component";
import { CompanyAttachmentService } from "./company-attachment.service";
import { CreateCompanyAttachmentService } from "./create-company-attachment/create-company-attachment.service";

@NgModule({
  declarations: [CompanyAttachmentComponent],
  imports: [CoreModule, SharedModule],
  exports: [CompanyAttachmentComponent],
  providers: [CompanyAttachmentService, CreateCompanyAttachmentService],
})
export class CompanyAttachmentModule {}
